import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import Confirmation from 'components/Confirmation/Confirmation.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import constructBuilding, { closeConstructConfirmation } from 'state/actions/building_construction'
import { BUILDING_TITLES, CANCEL } from 'helpers/i18n.jsx'

import {
    CONSTRUCT_CONFIRMATION_TITLE,
    CONSTRUCT_CONFIRMATION_SUBMIT,
    CONSTRUCT_CONFIRMATION_QUESTION,
} from './constants.jsx'


export class ConstructConfirmation extends React.Component {
    static propTypes = {
        slotId: PropTypes.number.isRequired,
        building: PropTypes.object.isRequired,
        constructCost: PropTypes.number.isRequired,
        opened: PropTypes.bool.isRequired,
        constructBuilding: PropTypes.func.isRequired,
        handleClose: PropTypes.func.isRequired,
    }
    render() {
        return (
            <Confirmation
                title={CONSTRUCT_CONFIRMATION_TITLE}
                submitCaption={CONSTRUCT_CONFIRMATION_SUBMIT}
                closeCaption={CANCEL}
                opened={this.props.opened}
                onSubmit={this.props.constructBuilding.bind(null, this.props.slotId, this.props.building.type)}
                onClose={this.props.handleClose}
            >
                <p>
                    {CONSTRUCT_CONFIRMATION_QUESTION(
                        BUILDING_TITLES[this.props.building.type],
                        <IndustrialResource value={this.props.constructCost} small/>
                    )}
                </p>
            </Confirmation>
        )
    }
}

export const mapStateToProps = (state, { slotId, building }) => ({
    opened: state.buildingConstruction.confirmationOpened,
    slotId,
    building,
    constructCost: state.settings.buildings[building.type].costs[0],
})

const mapDispatchToProps = {
    constructBuilding,
    handleClose: closeConstructConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(ConstructConfirmation)



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructConfirmation/ConstructConfirmation.jsx